import Form from 'mobx-react-form';
import * as validatorjs from 'validatorjs';

const plugins = { dvr: validatorjs };

const fields = {
    name: {
        name: 'listName',
        key: 'name',
        label: 'Name',
        rules: 'string|required|between:4,150',
        placeholder: 'e.g. Human Resources',
    },
};

class ListForm extends Form {
    constructor(setup, options) {
        super({ fields, ...setup }, { plugins, ...options });
    }
}

export default ListForm;
